import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function AccountsList() {
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    fetch('/api/v1/accounts').then(r=>r.json()).then(j => { if (j.success) setAccounts(j.accounts); });
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h2>Game Accounts</h2>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {accounts.map(a => (
          <div key={a._id} style={{ border: '1px solid #ddd', padding: 12, width: 280 }}>
            <img src={a.images?.[0] || '/placeholder.png'} alt={a.title} style={{ width:'100%', height:160, objectFit:'cover' }} />
            <h3>{a.title}</h3>
            <p>{a.description?.slice(0,120)}...</p>
            <Link to={`/accounts/${a._id}`}>View</Link>
          </div>
        ))}
      </div>
    </div>
  );
}
